import { cn } from "../../utils/cn";
import { getNotificationChannelBadge } from "../../utils/notificationChannelBadge";

type Props = {
  channel: "email" | "whatsapp";
  className?: string;
};

export function ChannelBadge({ channel, className }: Props) {
  const badge = getNotificationChannelBadge(channel);

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-semibold leading-tight",
        badge.className,
        className
      )}
    >
      {badge.label}
    </span>
  );
}
